const FLEX_ROW_ALIGN_OPTIONS = {
  left: 'justify-start',
  center: 'justify-center',
  right: 'justify-end',
};

const FLEX_COLUMN_ALIGN_OPTIONS = {
  left: 'items-start',
  center: 'items-center',
  right: 'items-end',
};

interface Props {
  alignment: 'left' | 'center' | 'right';
  includesFlexRow: boolean;
  includesFlexColumn: boolean;
}

export const serializerFlexAlignment = ({ alignment, includesFlexRow, includesFlexColumn }: Props) => {
  const alignmentClass = FLEX_ROW_ALIGN_OPTIONS[alignment || 'left'];
  const flexColumnAlignmentClass = FLEX_COLUMN_ALIGN_OPTIONS[alignment || 'left'];
  const flexAlignmentClass = includesFlexRow ? alignmentClass : includesFlexColumn ? flexColumnAlignmentClass : '';

  return flexAlignmentClass;
};
